<div class="modal fade" id="performa_broker_manager" tabindex="-1" aria-hidden="true">
	<div class="modal-dialog modal-dialog modal-fullscreen p-9">
		<div class="modal-content">
			<div class="modal-header p-3 d-flex justify-content-between bg-secondary">
				<h2>Broker Manager</h2>
				<div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal">
					<i class="ki-duotone ki-cross fs-1">
						<span class="path1"></span>
						<span class="path2"></span>
					</i>
				</div>
			</div>
			<div class="modal-body scroll-y mh-90 p-10">
				<form action="" class="form fv-row row">
					<div class="col-md-2 mb-5">
						<input type="text" name="brokerName" id="brokerName" class="form-control h-40px fs-7" placeholder="Name" />
					</div>
					<div class="col-md-2 mb-5">
						<input type="email" name="brokerEmail" id="brokerEmail" class="form-control h-40px fs-7" placeholder="Email" />
					</div>
					<div class="col-md-2 mb-5">
						<input type="tel" name="brokerPhone" id="brokerPhone" class="form-control h-40px fs-7" placeholder="Telephone" />
					</div>
					<div class="col-md-2 mb-5">
						<input type="text" name="brokerCity" id="brokerCity" class="form-control h-40px fs-7" placeholder="City" />
					</div>
					<div class="col-md-2 mb-5">
						<select class="form-select h-40px fs-7" name="brokerCountry" id="brokerCountry" aria-label="Select Country" data-kt-select2="true" data-placeholder="Select Country">
							<option value="" selected>Select Country</option>
							<option *ngFor="let country of countryList" [value]="country.code">{{ country.name }}</option>
						</select>
					</div>
					<div class="col-md-2 mb-5">
						<textarea name="brokerAddress" id="brokerAddress" class="form-control h-40px fs-7" placeholder="Address"></textarea>
					</div>
					<div class="col-md-2 mb-5">
						<button type="reset" class="btn w-100 btn-sm btn-outline btn-light">Clear</button>
					</div>
					<div class="col-md-2 mb-5">
						<button type="submit" class="btn w-100 btn-sm btn-primary">Add</button>
					</div>
				</form>
				<div class="separator border-gray-200 mb-5"></div>
				<form class="fv-row row" data-kt-subscription-table-filter="form">
					<div class="col-md-9 mb-5">
						<div class="d-flex align-items-center position-relative">
							<i class="ki-duotone ki-magnifier fs-3 position-absolute ms-5">
								<span class="path1"></span>
								<span class="path2"></span>
							</i>
							<input type="text" name="brokerSearch" id="brokerSearch" data-kt-subscription-table-filter="search" class="form-control form-control-solid w-100 h-40px fs-7 ps-12" placeholder="Search eg. Name, City, Country, Email">
						</div>
					</div>
					<div class="col-md-3" data-kt-subscription-table-toolbar="base">
						<div class="fv-row row">
							<div class="col-md-6 mb-5">
								<!--begin::Filter-->
								<button type="button" class="btn btn-sm btn-primary w-100 fs-7" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">
									<i class="ki-duotone ki-filter fs-2">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>Filter</button>
								<!--begin::Menu 1-->
								<div class="menu menu-sub menu-sub-dropdown w-300px w-md-325px" data-kt-menu="true">
									<!--begin::Header-->
									<div class="px-7 py-5">
										<div class="fs-5 text-gray-900 fw-bold">Filter Options</div>
									</div>
									<!--end::Header-->
									<!--begin::Separator-->
									<div class="separator border-gray-200"></div>
									<!--end::Separator-->
									<!--begin::Content-->
									<div class="px-7 py-5">
										<!--begin::Input group-->
										<div class="mb-10">
											<label class="form-label fs-7 fw-semibold  mb-2">Month:</label>
											<select class="form-select form-select-solid h-40px fs-7 fw-bold" data-kt-select2="true" data-placeholder="Select option" data-allow-clear="true" data-kt-subscription-table-filter="month" data-hide-search="true">
												<option value="" selected>Select Month</option>
												<option *ngFor="let month of monthList" [value]="month.value">{{ month.label }}</option>
											</select>
										</div>
										<!--end::Input group-->
										<!--begin::Input group-->
										<div class="mb-10">
											<label class="form-label fs-7 fw-semibold  mb-2">Status:</label>
											<select class="form-select form-select-solid fw-bold" data-kt-select2="true" data-placeholder="Select option" data-allow-clear="true" data-kt-subscription-table-filter="status" data-hide-search="true">
												<option></option>
												<option value="Active">Active</option>
												<option value="Expiring">Expiring</option>
												<option value="Suspended">Suspended</option>
											</select>
										</div>
										<!--end::Input group-->
										<!--begin::Input group-->
										<div class="mb-10">
											<label class="form-label fs-7 fw-semibold  mb-2">Billing Method:</label>
											<select class="form-select form-select-solid fw-bold" data-kt-select2="true" data-placeholder="Select option" data-allow-clear="true" data-kt-subscription-table-filter="billing" data-hide-search="true">
												<option></option>
												<option value="Auto-debit">Auto-debit</option>
												<option value="Manual - Credit Card">Manual - Credit Card</option>
												<option value="Manual - Cash">Manual - Cash</option>
												<option value="Manual - Paypal">Manual - Paypal</option>
											</select>
										</div>
										<!--end::Input group-->
										<!--begin::Input group-->
										<div class="mb-10">
											<label class="form-label fs-6 fw-semibold">Product:</label>
											<select class="form-select form-select-solid fw-bold" data-kt-select2="true" data-placeholder="Select option" data-allow-clear="true" data-kt-subscription-table-filter="product" data-hide-search="true">
												<option></option>
												<option value="Basic">Basic</option>
												<option value="Basic Bundle">Basic Bundle</option>
												<option value="Teams">Teams</option>
												<option value="Teams Bundle">Teams Bundle</option>
												<option value="Enterprise">Enterprise</option>
												<option value=" Enterprise Bundle">Enterprise Bundle</option>
											</select>
										</div>
										<!--end::Input group-->
										<!--begin::Actions-->
										<div class="d-flex justify-content-end">
											<button type="reset" class="btn btn-light btn-active-light-primary fw-semibold me-2 px-6" data-kt-menu-dismiss="true" data-kt-subscription-table-filter="reset">Reset</button>
											<button type="submit" class="btn btn-primary fw-semibold px-6" data-kt-menu-dismiss="true" data-kt-subscription-table-filter="filter">Apply</button>
										</div>
										<!--end::Actions-->
									</div>
									<!--end::Content-->
								</div>
								<!--end::Menu 1-->
								<!--end::Filter-->
							</div>
							<div class="col-md-6 mb-5">
								<!--begin::Export-->
								<button type="button" class="btn btn-sm btn-primary w-100 fs-7" data-bs-toggle="modal" data-bs-target="#kt_export_modal">
									<i class="ki-duotone ki-exit-up fs-2">
										<span class="path1"></span>
										<span class="path2"></span>
									</i>Export</button>
								<!--end::Export-->
							</div>
						</div>
					</div>
					<div class="col-md-4 mb-5">
						<!--begin::Group actions-->
						<div class="d-flex justify-content-end align-items-center d-none" data-kt-subscription-table-toolbar="selected">
							<div class="fw-bold me-5">
								<span class="me-2" data-kt-subscription-table-select="selected_count"></span>Selected
							</div>
							<button type="button" class="btn btn-danger" data-kt-subscription-table-select="delete_selected">Delete Selected</button>
						</div>
						<!--end::Group actions-->
					</div>
					<!--begin::Table-->
					<table class="table align-middle table-row-dashed fs-6 gy-5" id="kt_subscriptions_table">
						<thead>
							<tr class="text-start text-muted fw-bold fs-7 text-uppercase gs-0">
								<th class="w-10px pe-2">
									<div class="form-check form-check-sm form-check-custom form-check-solid me-3">
										<input class="form-check-input" type="checkbox" data-kt-check="true" data-kt-check-target="#kt_subscriptions_table .form-check-input" value="1" />
									</div>
								</th>
								<th class="min-w-125px">Customer</th>
								<th class="min-w-125px">Status</th>
								<th class="min-w-125px">Billing</th>
								<th class="min-w-125px">Product</th>
								<th class="min-w-125px">Created Date</th>
								<th class="text-end min-w-70px">Actions</th>
							</tr>
						</thead>
						<tbody class="text-gray-600 fw-semibold">
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Emma Smith</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Basic</td>
								<td>Aug 19, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Melody Macy</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Credit Card</div>
								</td>
								<td>Basic</td>
								<td>Dec 20, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Max Smith</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Cash</div>
								</td>
								<td>Teams Bundle</td>
								<td>Aug 19, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Sean Bean</a>
								</td>
								<td>
									<div class="badge badge-light-warning">Expiring</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Paypal</div>
								</td>
								<td>Enterprise</td>
								<td>Feb 21, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Brian Cox</a>
								</td>
								<td>
									<div class="badge badge-light-warning">Expiring</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Basic</td>
								<td>Dec 20, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Mikaela Collins</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Enterprise Bundle</td>
								<td>Oct 25, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Francis Mitcham</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Teams</td>
								<td>Jun 20, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Olivia Wild</a>
								</td>
								<td>
									<div class="badge badge-light-danger">Suspended</div>
								</td>
								<td>
									<div class="badge badge-light">--</div>
								</td>
								<td>Enterprise</td>
								<td>Sep 22, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Neil Owen</a>
								</td>
								<td>
									<div class="badge badge-light-warning">Expiring</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Basic</td>
								<td>Oct 25, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Dan Wilson</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Enterprise Bundle</td>
								<td>Sep 22, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Emma Bold</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Credit Card</div>
								</td>
								<td>Enterprise</td>
								<td>Nov 10, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Ana Crown</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Credit Card</div>
								</td>
								<td>Basic</td>
								<td>Aug 19, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Robert Doe</a>
								</td>
								<td>
									<div class="badge badge-light-danger">Suspended</div>
								</td>
								<td>
									<div class="badge badge-light">--</div>
								</td>
								<td>Teams Bundle</td>
								<td>Feb 21, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">John Miller</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Paypal</div>
								</td>
								<td>Enterprise</td>
								<td>Oct 25, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Lucy Kunic</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Credit Card</div>
								</td>
								<td>Basic</td>
								<td>Feb 21, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Neil Owen</a>
								</td>
								<td>
									<div class="badge badge-light-danger">Suspended</div>
								</td>
								<td>
									<div class="badge badge-light">--</div>
								</td>
								<td>Basic Bundle</td>
								<td>Jul 25, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Dan Wilson</a>
								</td>
								<td>
									<div class="badge badge-light-warning">Expiring</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Paypal</div>
								</td>
								<td>Enterprise</td>
								<td>Jun 20, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Emma Smith</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Auto-debit</div>
								</td>
								<td>Teams</td>
								<td>Sep 22, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Melody Macy</a>
								</td>
								<td>
									<div class="badge badge-light-success">Active</div>
								</td>
								<td>
									<div class="badge badge-light">Manual - Credit Card</div>
								</td>
								<td>Basic</td>
								<td>Oct 25, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
							<tr>
								<td>
									<div class="form-check form-check-sm form-check-custom form-check-solid">
										<input class="form-check-input" type="checkbox" value="1" />
									</div>
								</td>
								<td>
									<a href="apps/customers/view.html" class="text-gray-800 text-hover-primary mb-1">Max Smith</a>
								</td>
								<td>
									<div class="badge badge-light-danger">Suspended</div>
								</td>
								<td>
									<div class="badge badge-light">--</div>
								</td>
								<td>Basic Bundle</td>
								<td>Sep 22, 2024</td>
								<td class="text-end">
									<a href="#" class="btn btn-light btn-active-light-primary btn-sm" data-kt-menu-trigger="click" data-kt-menu-placement="bottom-end">Actions
										<i class="ki-duotone ki-down fs-5 m-0"></i></a>
									<!--begin::Menu-->
									<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-semibold fs-7 w-125px py-4" data-kt-menu="true">
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Edit</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="" class="menu-link px-3">Choose</a>
										</div>
										<!--end::Menu item-->
										<!--begin::Menu item-->
										<div class="menu-item px-3">
											<a href="#" data-kt-subscriptions-table-filter="delete_row" class="menu-link px-3">Delete</a>
										</div>
										<!--end::Menu item-->
									</div>
									<!--end::Menu-->
								</td>
							</tr>
						</tbody>
					</table>
					<!--end::Table-->
				</form>
			</div>
			<div class="modal-footer" #modalFooter>
			</div>
		</div>
	</div>
</div>